export default __webpack_public_path__ + "static/media/time.88f995d9.png";